import angular from 'angular';
import UIRouter from 'angular-ui-router';

import './styles/index.scss';
import template from './index.html';
import AdminController from './AdminController';

    
let namespace = angular.module('olr-mainfe-admin', [
  UIRouter,
  'olr-common'
]);

namespace.config(function($stateProvider) {
  $stateProvider.state('olr.mainfe.admin', {
    url: '/admin',
    controller: AdminController,
    controllerAs: 'adminCtrl',
    template: template
  });
});

namespace.controller('AdminController', AdminController);

export default namespace.name;





/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-admin/index.js
 **/